import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, TextField, Box, Grid,
    Button, Typography,
    MenuItem,
    Tab,
    DialogActions,
    TableCell,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Checkbox,
    Snackbar,
    Autocomplete
} from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import AddIcon from '@mui/icons-material/Add';
import { v4 as uuidv4 } from "uuid";
import CancelIcon from '@mui/icons-material/Cancel';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SaveIcon from '@mui/icons-material/Save';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ERPinput, ERPinputNo } from '../reusableComponent/ErpTextField';
import styles from '../../styles.module.css';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { StyledTableCell, StyledTableRow } from '../reusableComponent/StyledTable';
import { UploadFileAttachment, addCustomerSupplierPayment, editDeleteCustomerSupplierPayment, getBankList, getCNSList, getCustomerSupplierPendingPaymentList } from '../../actions/actions';
import { dateConversionOnEntryPage, dateConversionOnEntryPageWithTime } from '../reusableComponent/dateConversionOnEntryPage';
import PaymentInvoiceDetails from './PaymentInvoiceDetails';
import { BootstrapDialog, BootstrapDialogTitle } from '../reusableComponent/BootstrapDialog';
import PaymentInvoiceDeduction from './PaymentInvoiceDeduction';
import { financialYear } from '../reusableComponent/financialYear';
import Breadcrumb from '../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../reusableComponent/BackBtn';
var FormData = require("form-data");

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

const Customer_Supplier_PaymentAdd = () => {
    const urlLocation = useLocation();
    const prName = urlLocation.state === null ? undefined : urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const backBtnLen = urlLocation.state.backBtn;
    const classes = useStyles();
    const dispatch = useDispatch()

    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [successMessage1, setSuccessMessage1] = useState(null);

    let navigate = useNavigate();
    const location = useLocation();
    const [isUpdateArray, setIsUpdateArray] = useState(false);
    const editData = editInfo && editInfo;
    const editid = editData && editData.CNS_payment_id;

    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [openOption, setOpenOption] = useState('');


    const [totalPaidAmt, setTotalPaidAmt] = useState(editData ? editData.totalPaidAmt : '');
    const [totalDue, setTotalDue] = useState(editData ? editData.totalDue : 0);
    const [payment_date, setPaymentDate] = React.useState(editData ? dayjs(editData.payment_date) : dayjs(new Date()));

    const [CNS_id, setCNS_id] = useState(editData ? editData.CNS_id : prName ? prName : null);
    const [bank_id, setBank] = useState(editData ? editData.bank_id : null);
    // const [inputFields, setInputFields] = useState([]);
    const file_attachment = useSelector(state => state.customer_supplier_payment.fileAttachment)

    const [inputFields, setInputFields] = useState(
        editData && editData.CNS_payment_id ? JSON.parse(editData.childRows) :
            [{
                id: uuidv4(),
                invoiceId: '',
                invoiceNo: '',
                invoiceDate: '',
                dueDate: '',
                CNS_id: '',
                CNS_Name: '',
                CNS_Type: '',
                invoiceAmount: '',
                remainingtoPay: '',
                amountTopay: 0,
                clearPayment: 0,
                totalDueAmount: '',
                totalPaid: '',
                payments: '',
            },
            ]);


    const [data, setData] = useState({
        id: editid,
        amount: editData ? editData.amount : 0,
        payment_mode: editData ? editData.payment_mode : '',
        remark: editData ? editData.remark : '',
        instrumentNo: editData ? editData.instrumentNo : '',
    });

    const handleChangePaymentDate = (newValue) => {
        setPaymentDate(newValue);
    };

    const handleAmount = (e) => {
        const value = Math.max(0, Math.min(totalDue, Number(e.target.value)).toFixed(2));
        setTotalPaidAmt(value);
    }

    const CNS_list = useSelector(state => state.CNS.CNS)
    const bankList = useSelector(state => state.bank.bank)
    const pendingPaymentList = useSelector(state => state.customer_supplier_payment.customer_supplier_pending_payment)


    const handleChangeBank = (event, newValue) => {
        setBank(newValue)
    }

    const handleChangeCNS = (event, newValue) => {
        setCNS_id(newValue)
        // {
        //     CNS_Name: newValue.CNS_Name,   
        //     CNS_Type: newValue.CNS_Type,  
        //     CSNId: newValue.CSNId,  
        //     creditPeriod: newValue.creditPeriod,  
        // }
        dispatch(getCustomerSupplierPendingPaymentList({ companyId: userInfo.companyId, CNS_Type: newValue == null ? null : newValue.CNS_Type, CNS_id: newValue == null ? null : newValue.CSNId }))
    }

    const [successMessage, setSuccessMessage] = useState(null);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.customer_supplier_payment.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    var containsSales = location.pathname.includes('/sales/');

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setShouldShowMsg(true);
                // navigate(-1, { responseMessage });
                navigate(containsSales == true ? '/sales/customer-payment' : '/purchase/supplier-payment' , { state: { backBtnTab: backBtnLen, responseMessage } });
            }
        }
    }, [shouldShowMsg, responseMessage, backBtnLen]);

    useEffect(() => {
        const totalSum = pendingPaymentList.length > 0 && pendingPaymentList.reduce((sum, item) => {
            return sum + parseFloat(item.totalDueAmount);
        }, 0);
        setTotalDue(parseFloat(editid ? editData.totalDue : totalSum).toFixed(2));

        const newArr = []
        if (editData && editData.CNS_payment_id) {

            JSON.parse(editData.childRows).map((row) => (
                newArr.push({
                    invoiceId: row.invoiceId,
                    invoiceNo: row.invoiceNo,
                    invoiceDate: row.invoiceDate,
                    dueDate: row.dueDate,
                    CNS_id: row.CNS_id,
                    CNS_Name: row.CNS_Name,
                    CNS_Type: row.CNS_Type,
                    invoiceAmount: row.invoiceAmount,
                    remainingtoPay: row.totalDueAmount,
                    amountTopay: row.amountTopay,
                    clearPayment: row.clearPayment,
                    totalDueAmount: row.totalDueAmount,
                    totalPaid: row.totalPaid,
                    payments: row.payments,
                })
            ))

            setInputFields(newArr)


        } else {

            const initialInputFields = pendingPaymentList.length > 0 && pendingPaymentList.map((row, index) => ({
                invoiceId: row.invoiceId,
                invoiceNo: row.invoiceNo,
                invoiceDate: row.invoiceDate,
                dueDate: row.dueDate,
                CNS_id: row.CNS_id,
                CNS_Name: row.CNS_Name,
                CNS_Type: row.CNS_Type,
                invoiceAmount: row.invoiceAmount,
                remainingtoPay: row.remainingtoPay,
                amountTopay: 0,
                clearPayment: 0,
                totalDueAmount: row.totalDueAmount,
                totalPaid: row.totalPaid,
                payments: row.payments,
            }));

            setInputFields(initialInputFields);
        }
    }, [pendingPaymentList]);

    useEffect(() => {
        dispatch(getBankList({ companyId: userInfo.companyId }))
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: location.pathname == '/sales/add-customer-payment' ? 'Customer' : 'Supplier' }))
        if (editData) {
            setCNS_id({
                CNS_Name: editData.CNS_Name,
                CSNId: editData.CNS_id,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                pinCode: editData.pinCode,
                state: editData.state,
            })
            setBank({
                bankName: editData.bankName,
                branchCode: editData.branchCode,
                id: editData.bank_id,
            })
        }
    }, []);

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = array[i];
        result[e.target.name] = e.target.value;

        if (e.target.name == 'clearPayment') {
            result[e.target.name] = e.target.checked;

            if (e.target.checked == true) {
                result['amountTopay'] = result['amountTopay'] === 0 ? parseFloat(result['remainingtoPay']).toFixed(2) : parseFloat(result['amountTopay']).toFixed(2);
                result['dueAmount'] = 0
                array[i] = result;
            } else {
                result['amountTopay'] = 0;
                result['dueAmount'] = result['remainingtoPay']
                array[i] = result;
            }
        }

        array[i] = result;
        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);

        if (e.target.name == 'amountTopay') {
            result['amountTopay'] = Math.max(0, Math.min(result['remainingtoPay'], Number(e.target.value)).toFixed(2));
            let calVal = parseFloat(result['pendingAmount']) - parseFloat(result['amountTopay']);
            result['dueAmount'] = calVal;
            
            if(parseFloat(result['remainingtoPay']).toFixed(2) === parseFloat(e.target.value).toFixed(2)){
                result['clearPayment'] = true;
            }

            array[i] = result;
        }

        const reducer = (previousValue, currentValue) => previousValue + currentValue;
        const totalCount = inputFields && inputFields.map(value => value.amountTopay && value.amountTopay ? parseFloat(value.amountTopay) : 0).reduce(reducer);
        // setTotalPaidAmt(totalCount);
    };

    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };

    const uploadFile = async (event) => {
        try {
            const selectedFile = event.target.files[0];
            const formData = new FormData();
            formData.append('file', selectedFile);
            await dispatch(UploadFileAttachment(formData));
        } catch (error) {
            console.error('Error uploading file:', error); // Log the error for debugging
        }
    };

    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PaymentInvoiceDetails')
    }
    const handleDeduction = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PaymentInvoiceDeduction')
    }

    const handleClose = (event, reason) => {
        setOpenPopup(false);
    };

    const onSubmit = (event) => {
        const totalSum = inputFields.reduce((sum, item) => {
            return sum + parseFloat(item.amountTopay);
        }, 0);
        if (totalSum != totalPaidAmt) {
            alert("Payment amount mismatch!")
        } else {
            const sending_data = {
                companyId: userInfo.companyId,
                id: editid,
                ...data,
                CNS_Type: CNS_id.CNS_Type,
                CNS_id: CNS_id.CSNId,
                bank_id: data.payment_mode == 'Cash' ? null : bank_id.id,
                payment_date: dateConversionOnEntryPage(payment_date),
                totalPaidAmt: totalPaidAmt,
                totalDue: totalDue,
                childRows: inputFields,
                file_attachment: file_attachment == '' ? editData ? editData.file_attachment : file_attachment : file_attachment,
                finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, payment_date.$M, payment_date.$y),
                createdBy: editData ? editData.createdBy : userInfo.userId,
                createdAt: editData ? editData.createdAt : dateConversionOnEntryPageWithTime(new Date()),
                modifiedBy: editData ? userInfo.userId : null,
                modifiedAt: editData ? dateConversionOnEntryPageWithTime(new Date()) : '',
                changedUpdatedValue: 'edit',
            }
            if (editData) {
                dispatch(editDeleteCustomerSupplierPayment(sending_data));
            } else {
                dispatch(addCustomerSupplierPayment(sending_data));
            }
        }
    }

    const handleCloseSuccessMsg1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage1(false)
    };

    const actionMsg1 = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg1}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
           <Breadcrumb
                        routeSegments={[
                            { name: location.pathname == '/sales/add-customer-payment' ? 'Sales' : 'Purchase', path: location.pathname == '/sales/add-customer-payment' ? '/sales/' : '/purchase/' },
                            { name: location.pathname == '/sales/add-customer-payment' ? 'Customer Payment' : 'Supplier Payment', path: location.pathname == '/sales/add-customer-payment' ? '/sales/customer-payment' : '/purchase/supplier-payment' },
                            { name: location.pathname == '/sales/add-customer-payment' ? 'Create Customer Payment' : 'Create Supplier Payment' },
                        ]}
                    />
            <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                 <Box sx={{ m: 2}} > </Box>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box>
                        <Grid container spacing={1} sx={{}}>
                            {editData ?
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Reference No</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <ERPinput
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            size='small'
                                            fullWidth
                                            name="paymentReferenceNo"
                                            type="text"
                                            onChange={handleChange}
                                            value={editData.paymentReferenceNo}
                                        />
                                    </Grid>
                                </>
                                :
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Reference No</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <div className={`${styles.skeleton_text}`}>
                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}> </Typography>
                                        </div>
                                    </Grid>
                                </>
                            }
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Payment Date</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        name="payment_date"
                                        inputFormat="DD/MM/YYYY"
                                        value={payment_date}
                                        onChange={handleChangePaymentDate}
                                        renderInput={(params) => <ERPinput  {...params} size='small'

                                            fullWidth />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>
                                    {location.pathname == '/sales/add-customer-payment' ? 'Customer Name' : 'Supplier Name'}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={CNS_list}
                                    value={CNS_id}
                                    onChange={handleChangeCNS}
                                    getOptionLabel={(option) => option.CNS_Name}
                                    getOptionSelected={(option, value) => option.id === value.CSNId}
                                    renderInput={(params) =>
                                        <ERPinput required
                                            placeholder={location.pathname == '/sales/add-customer-payment' ? "Please Select  Customer" : "Please Select Supplier"}
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: 25,
                                                    fontSize: 12,
                                                }
                                            }} {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Amount</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    required
                                    size='small'
                                    fullWidth
                                    name="totalPaidAmt"
                                    type="number"
                                    onChange={(e) => handleAmount(e)}
                                    value={totalPaidAmt}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Payment Mode</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    fullWidth
                                    required
                                    select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="payment_mode"
                                    value={data.payment_mode}
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value="Cash" className={`${styles.erp_lable}`}>Cash</MenuItem>
                                    <MenuItem value="Bank" className={`${styles.erp_lable}`}>Bank</MenuItem>
                                    <MenuItem value="NEFT" className={`${styles.erp_lable}`}>NEFT</MenuItem>
                                    <MenuItem value="IMPS" className={`${styles.erp_lable}`}>IMPS</MenuItem>
                                    <MenuItem value="RTGS" className={`${styles.erp_lable}`}>RTGS</MenuItem>
                                    <MenuItem value="Cheque" className={`${styles.erp_lable}`}>Cheque</MenuItem>
                                </ERPinput>
                            </Grid>
                            {data.payment_mode !== 'Cash' &&
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Payment Through</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <Autocomplete
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={bankList}
                                            value={bank_id}
                                            onChange={handleChangeBank}
                                            getOptionLabel={(option) => option.bankName + ' (' + option.branchCode + ')'}
                                            getOptionSelected={(option, value) => option.id === value.bank_id}
                                            renderInput={(params) => <ERPinput
                                                placeholder="Please Select Bank Name"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12,
                                                    }
                                                }} {...params} />}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Instrument/UTR No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="instrumentNo"
                                    value={(data.instrumentNo)}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Total Due Amount</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    name="totalDue"
                                    type="number"
                                    onChange={handleChange}
                                    value={totalDue}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Remarks</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    fullWidth
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="remark"
                                    value={(data.remark)}
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                >
                                </ERPinput>
                            </Grid>

                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Attach File</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`} >
                                <div >
                                    <input accept="image/*,application/pdf" style={{ display: 'none' }} name="file_attachment" id="contained-button-file" type="file" onChange={uploadFile} />
                                    <label htmlFor="contained-button-file">
                                        <Box sx={{ display: '', justifyContent: 'center' }}>
                                            <Button component="span" color="primary" variant="contained" sx={{ borderRadius: '10px', fontSize: '10px', textTransform: 'none', backgroundColor: '#00637c' }}>
                                                <CloudUploadIcon style={{ fontSize: '15px', marginRight: '4px' }} />
                                            </Button>
                                            {/* <span style={{ fontSize: '10px' }}>   {imageFileName}</span> */}
                                        </Box>
                                    </label>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                    <br />
                    <TableContainer component={Paper} sx={{ overflowY: 'auto', maxHeight: 200 }}>
                        <Table sx={{ minWidth: 1000 }} size="small" aria-label="a dense table" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>Invoice No </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>Invoice Date</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>Due Date</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`}>Invoice Amount</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`}>Due Amount</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`}>Payment</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`} width="8%">Close Invoice</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`} width="8%"> Deduction </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {CNS_id !== null &&
                                    inputFields && inputFields.map((row, index) => {
                                        return (
                                            <StyledTableRow
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                {editData && editData.CNS_payment_id ?
                                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} >
                                                        <span > {row.invoiceNo}</span>
                                                    </StyledTableCell>
                                                    :
                                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                                        <span style={{ cursor: 'pointer', color: 'blue' }} > {row.invoiceNo}</span>
                                                    </StyledTableCell>
                                                }
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                    <Typography className={`${styles.erp_lable}`}>{row.invoiceDate}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                    <Typography className={`${styles.erp_lable}`}>{row.dueDate}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(row.invoiceAmount).toFixed(2)}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(row.totalDueAmount).toFixed(2)}</Typography>
                                                </StyledTableCell>

                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                    <ERPinputNo
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                "& input": {
                                                                    textAlign: 'right',
                                                                    fontSize: '12px',
                                                                    "&:hover": {
                                                                        backgroundColor: '#ffff'
                                                                    },
                                                                }
                                                            }
                                                        }}
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="amountTopay"
                                                        value={row.amountTopay}
                                                        size='small'
                                                        onChange={(e) => handleMultipleInput(e, index)}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}

                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                                    <Checkbox sx={{ padding: '0px' }}
                                                        onChange={(e) => handleMultipleInput(e, index)}
                                                        name="clearPayment"
                                                        value={row.clearPayment}
                                                        checked={row.clearPayment}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        size="small"
                                                        color="success"
                                                    />
                                                </StyledTableCell>

                                                <StyledTableCell align="center" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDeduction(row)}>
                                                    View
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        );
                                    })}

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ marginTop: '12px', float: 'right', }}>
                        <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                        </Button>
                        <Cancel />
                    </Box>
                </form>
            </Paper>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        minWidth: "40%",
                        minHeight: "45%",
                        maxWidth: "50%",
                        maxHeight: "70%",
                    }
                }}
                onClose={handleClose}
                open={openPopup} >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'PaymentInvoiceDetails' && 'Payment Invoice Details'}
                    {openOption === 'PaymentInvoiceDeduction' && 'Payment Invoice Deduction Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {openOption === 'PaymentInvoiceDetails' &&
                        <PaymentInvoiceDetails details={info} />
                    }
                    {openOption === 'PaymentInvoiceDeduction' &&
                        <PaymentInvoiceDeduction details={info} />
                    }
                </DialogContent>
            </BootstrapDialog>


            {successMessage1 &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage1 ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg1}
                    message={successMessage1}
                    action={actionMsg1}
                />
            }

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }

        </>
    )
}
export default Customer_Supplier_PaymentAdd;